import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { assetUrl } from "@shared/helper/asset-url";

@Component({
    selector: "app-smartfleet-imprint-modal",
    templateUrl: "./imprint-modal.component.html",
    styleUrls: ["./imprint-modal.component.scss"],
    standalone: false
})
export class ImprintModalComponent implements OnInit {
  constructor(private dialog: MatDialogRef<ImprintModalComponent>) {}

  ngOnInit() {
    /* TODO document why this method 'ngOnInit' is empty */
  }

  generatePDFPath(typePDF: string) {
    let urltestre = "";
    if (typePDF == "pdfMaster") {
      urltestre = assetUrl(
        "files/BISB_SmartFleetplatform_V1.0_Master_OSS_Scan_Report_2021_07_12.pdf"
      );
    } else if (typePDF == "pdfBackendMaster") {
      urltestre = assetUrl(
        "files/BISB_SmartFleetplatform_V1.0_Backend_Master_OSS_Scan_Report_2021_08_02-1.pdf"
      );
    }
    window.open(urltestre, "_blank");
  }

  closeDialog(): void {
    this.dialog.close();
  }
}
